module.exports = __webpack_public_path__ + "static/img/抖音广告_03.12f809b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/mobile/gdd102/抖音广告_03.jpg
// module id = xNvV
// module chunks = 1